import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { PureComponent } from 'react';
import styles from './index.module.scss';
export class CSATWidgetMessage extends PureComponent {
    render() {
        const { className, children } = this.props;
        const rootClassName = classnames(styles.root, className);
        return _jsx("div", Object.assign({ className: rootClassName }, { children: children }));
    }
}
